// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(min-width: 601px)";
var _4 = "visaWrapper-cYLth";
var _5 = "passenger-q4_9n";
var _6 = "passenger__name-19ahE";
var _7 = "passenger__birth-3UeaL";
var _8 = "group-2VvCV";
var _9 = "group__field-2LqZw";
export { _1 as "__esModule", _2 as "mobile", _3 as "exclude_mobile", _4 as "visaWrapper", _5 as "passenger", _6 as "passenger__name", _7 as "passenger__birth", _8 as "group", _9 as "group__field" }
export default { "__esModule": _1, "mobile": _2, "exclude_mobile": _3, "visaWrapper": _4, "passenger": _5, "passenger__name": _6, "passenger__birth": _7, "group": _8, "group__field": _9 }
